import React from 'react';
import IncompleteCard from './incomplete_card';
import CompletedCard from './complete_card';

function SecondSectionCard(cardInfo) {
  const { status } = cardInfo;
  const SectionCard = status === 'completed' ? CompletedCard : IncompleteCard;

  return (
    <SectionCard {...cardInfo} />
  );
}

export default SecondSectionCard;
